let cwaUrlVar;
let assetUrlVar = '';
if (BUILD_TARGET === 'localdev' || BUILD_TARGET === 'localdev-mock') {
  cwaUrlVar = 'http://localhost:8000';
  assetUrlVar = 'https://betacontentmedia.mintel.com';
} else if (BUILD_TARGET === 'beta' || BUILD_TARGET === 'test') {
  cwaUrlVar = 'https://beta-clients.mintel.com';
  assetUrlVar = 'https://betacontentmedia.mintel.com';
} else if (BUILD_TARGET === 'live') {
  cwaUrlVar = 'https://clients.mintel.com';
  assetUrlVar = 'https://contentmedia.mintel.com';
} else {
  throw new Error(`Unexpected build target '${BUILD_TARGET}'`);
}

export const cwaUrl = cwaUrlVar;
export const assetUrl = assetUrlVar;
export const staticCwaUrl = `${cwaUrlVar}/static`;
export const portalUrl = 'https://portal.mintel.com/portal';
